import React, { useState, useEffect } from 'react';
import { Factory, Settings, Users, Building2, Package } from 'lucide-react';

const Home: React.FC = () => {
  const [currentSlide, setCurrentSlide] = useState<number>(0);

  const heroSlides = [
    {
      image: 'https://fbb.obs.cn-east-3.myhuaweicloud.com/jpg/20250714163845_B3bm71.jpg',
      title: '服帮帮 - 专业的服装加工交易平台',
      description: '致力于化解行业信任危机，直击并解决行业痛点，为订单公司、加工厂以及供应链各方打造值得信赖的交易空间。'
    }
  ];

  useEffect(() => {
    const timer = setTimeout(() => {
      setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
    }, 5000);
    return () => clearTimeout(timer);
  }, [currentSlide, heroSlides.length]);

  // section E 动画数字目标值
  const stats = [
    { icon: <Factory className="w-10 h-10 text-green-500 mb-2" />, value: 406, color: 'text-green-600', bg: 'bg-blue-50', label: '入驻工厂数量' },
    { icon: <Settings className="w-10 h-10 text-yellow-500 mb-2" />, value: 30823, color: 'text-yellow-600', bg: 'bg-yellow-50', label: '设备数量' },
    { icon: <Users className="w-10 h-10 text-red-500 mb-2" />, value: 27027, color: 'text-red-600', bg: 'bg-red-50', label: '工人数量' },
    { icon: <Building2 className="w-10 h-10 text-purple-500 mb-2" />, value: 22, color: 'text-purple-600', bg: 'bg-purple-50', label: '入驻订单企业数量' },
    // { icon: <Package className="w-10 h-10 text-orange-500 mb-2" />, value: 0, color: 'text-orange-600', bg: 'bg-orange-50', label: '订单量（待开放）' },
  ];

  // 动画数字状态
  const [animatedStats, setAnimatedStats] = useState(stats.map(() => 0));

  useEffect(() => {
    const duration = 1200; // 动画总时长ms
    const frameRate = 30; // 帧率
    const totalFrames = Math.round(duration / (1000 / frameRate));
    let frame = 0;
    const interval = setInterval(() => {
      frame++;
      setAnimatedStats(stats.map((stat, i) => {
        const progress = Math.min(frame / totalFrames, 1);
          return Math.floor(stat.value * progress);
      }));
      if (frame >= totalFrames) clearInterval(interval);
    }, 1000 / frameRate);
    return () => clearInterval(interval);
  }, []);

  // 联系我们二维码数据
  const contactQRCodes = [
    {
      img: "https://fbb.obs.cn-east-3.myhuaweicloud.com/jpg/20250714163702_B5myyB.jpg",
      alt: "小程序二维码",
      label: "小程序",
    },
    {
      img: "https://fbb.obs.cn-east-3.myhuaweicloud.com/jpg/20250714163747_1UAjM4.jpg",
      alt: "抖音号二维码",
      label: "抖音号",
    },
    {
      img: "https://fbb.obs.cn-east-3.myhuaweicloud.com/jpg/20250714163726_ZOaKaj.jpg",
      alt: "视频号二维码",
      label: "视频号",
    },
    {
      img: "https://fbb.obs.cn-east-3.myhuaweicloud.com/jpg/20250704113214_KYvQlA.jpg",
      alt: "微信号1二维码",
      label: "企业微信（加工厂）",
    },
    {
      img: "https://fbb.obs.cn-east-3.myhuaweicloud.com/jpg/20250410162159_juqa9Z.jpg",
      alt: "微信号2二维码",
      label: "企业微信（订单公司）",
    },
  ];

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative h-[480px] md:h-[600px] mt-16">
        <div className="absolute inset-0">
          <img
            src={heroSlides[currentSlide].image}
            alt={heroSlides[currentSlide].title}
            className="w-full h-full object-cover opacity-70"
          />
          <div className="absolute inset-0 bg-black/40"></div>
        </div>

        <div className="relative z-10 flex items-center justify-center h-full text-center text-white">
          <div className="max-w-4xl mx-auto px-4">
            <h1 className="text-[24px] md:text-[36px] font-bold mb-4 text-shadow">
              {heroSlides[currentSlide].title}
            </h1>
            <p className="text-[14px] md:text-[16px] mb-8 text-shadow">
              {heroSlides[currentSlide].description}
            </p>
            
      
          </div>
        </div>

        {/* Slide Indicators */}
        {heroSlides.length > 1 && (
          <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-2">
          {heroSlides.map((_, index) => (
            <button
              key={index}
              onClick={() => {
                console.log('index', index);
                setCurrentSlide(index)
              }}
              className={`w-4 h-4 rounded-full border-2 border-white transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-400 ${
                index === currentSlide ? 'bg-white' : 'bg-white/30 hover:bg-white/60'
              }`}
              aria-label={`切换到第${index + 1}张图`}
              tabIndex={0}
            />
          ))}
          </div>
        )}
       
      </section>
      {/* section A 区域性介绍 */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row items-center justify-between">
          {/* 左侧文本 */}
          <div className="md:w-1/2 w-full mb-8 md:mb-0 md:pr-12 text-center md:text-left">
            <h2 className="text-3xl font-bold mb-4">区域性</h2>
            <p className="text-lg text-gray-700">
              仅针对安徽南部以及周边省份城市的加工厂和以杭州为主的订单企业的，不做全国大范围的录入和服务。
            </p>
          </div>
          {/* 右侧图片 */}
          <div className="md:w-1/2 w-full flex justify-center">
            <img src="https://fbb.obs.cn-east-3.myhuaweicloud.com/jpg/20250714170358_OT5TV2.jpg" alt="区域性配图" className="rounded-2xl shadow-lg max-w-full h-auto" />
          </div>
        </div>
      </section>

      {/* section B 数据真实性 */}
      <section className="py-20 bg-blue-50">
  <div className="max-w-7xl mx-auto px-4">
    <h2 className="text-3xl font-bold text-center mb-4">数据真实性</h2>
    <p className="text-xl text-center text-gray-600 mb-12">
      企业在申请入驻后，平台会实地线下走访确保信息真实性。
    </p>

    {/* ✅ 外层容器，响应式宽度控制展示2个或5个 */}
    <div
      className="
        overflow-hidden 
        relative 
        mx-auto 
        max-w-full 
        w-[calc(2*15rem+1*16px)] 
        sm:w-[calc(5*15rem+4*16px)]
      "
    >
      {/* ✅ 内容容器 w-max 自动根据内容撑开，但不影响页面宽度 */}
      <div className="flex animate-marquee whitespace-nowrap w-max">
        {Array(2)
          .fill(0)
          .flatMap((_, repeatIdx) =>
            [...Array(10)].map((_, i) => {
              const imageUrls = [
                'https://fbb.obs.cn-east-3.myhuaweicloud.com/jpg/20250714164946_QPArR9.jpg',
                'https://fbb.obs.cn-east-3.myhuaweicloud.com/jpg/20250714165016_VTSLcM.jpg',
                'https://fbb.obs.cn-east-3.myhuaweicloud.com/jpg/20250714165037_aRkhwm.jpg',
                'https://fbb.obs.cn-east-3.myhuaweicloud.com/jpg/20250714165106_OUn7xV.jpg',
                'https://fbb.obs.cn-east-3.myhuaweicloud.com/jpg/20250714165123_4M0GYf.jpg',
                'https://fbb.obs.cn-east-3.myhuaweicloud.com/jpg/20250714165140_Phq32e.jpg',
                'https://fbb.obs.cn-east-3.myhuaweicloud.com/jpg/20250714165157_XsDmkF.jpg',
                'https://fbb.obs.cn-east-3.myhuaweicloud.com/jpg/20250714165213_LbGKi7.jpg',
                'https://fbb.obs.cn-east-3.myhuaweicloud.com/jpg/20250714165228_eZDB0f.jpg',
                'https://fbb.obs.cn-east-3.myhuaweicloud.com/jpg/20250714165242_wfy57u.jpg',
              ];
              return (
                <img
                  key={repeatIdx * 10 + i}
                  src={imageUrls[i % imageUrls.length]}
                  alt={`Image ${i + 1}`}
                  className="h-80 w-60 mx-2 rounded-xl shadow-lg object-cover"
                />
              );
            })
          )}
      </div>

    </div>
  </div>
</section>







      {/* section C 专业调解服务 */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-4">专业调解服务</h2>
          <p className="text-xl text-center text-gray-600 mb-12">服帮帮平台提供专业调解服务，快速解决合作纠纷，保障各方权益，维护行业秩序</p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            {/* 左侧图片 */}
            <div className="flex justify-center">
              <img src="https://fbb.obs.cn-east-3.myhuaweicloud.com/jpg/20250714214804_AGFdG4.jpg" alt="专业调解服务配图" className="rounded-xl shadow max-w-full h-80 object-cover" />
            </div>
            {/* 右侧文本：调解流程 */}
            <div>
              <h3 className="text-2xl font-semibold mb-4">调解流程</h3>
              <ul className="space-y-4 text-gray-700 text-lg">
                <li className="flex items-start">
                  <span className="flex-shrink-0 w-8 h-8 rounded-full bg-blue-500 text-white flex items-center justify-center font-bold mr-4">1</span>
                  <div>
                    <div className="font-bold text-base">提交申请</div>
                    <div className="text-gray-600 text-sm">在线填写调解申请表，描述纠纷详情</div>
                  </div>
                </li>
                <li className="flex items-start">
                  <span className="flex-shrink-0 w-8 h-8 rounded-full bg-blue-500 text-white flex items-center justify-center font-bold mr-4">2</span>
                  <div>
                    <div className="font-bold text-base">材料审核</div>
                    <div className="text-gray-600 text-sm">调解员审核材料，确认调解可行性</div>
                  </div>
                </li>
                <li className="flex items-start">
                  <span className="flex-shrink-0 w-8 h-8 rounded-full bg-blue-500 text-white flex items-center justify-center font-bold mr-4">3</span>
                  <div>
                    <div className="font-bold text-base">双方沟通</div>
                    <div className="text-gray-600 text-sm">调解员组织双方沟通，了解各自诉求</div>
                  </div>
                </li>
                <li className="flex items-start">
                  <span className="flex-shrink-0 w-8 h-8 rounded-full bg-blue-500 text-white flex items-center justify-center font-bold mr-4">4</span>
                  <div>
                    <div className="font-bold text-base">调解方案</div>
                    <div className="text-gray-600 text-sm">提出专业调解方案，促进双方和解</div>
                  </div>
                </li>
                <li className="flex items-start">
                  <span className="flex-shrink-0 w-8 h-8 rounded-full bg-blue-500 text-white flex items-center justify-center font-bold mr-4">5</span>
                  <div>
                    <div className="font-bold text-base">达成协议</div>
                    <div className="text-gray-600 text-sm">签署调解协议，监督协议执行</div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* section D 企业信用评级体系 */}
      <section className="py-20 bg-gray-100">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-left mb-4">企业信用评级体系</h2>
          <p className="text-xl text-left text-gray-600 mb-12">服帮帮平台通过多维度的信用评估，帮助企业重建信用，获得更多的合作机会，推动行业健康发展。</p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-end">
            {/* 左侧图片及标题 */}
            <div className="flex flex-col items-center">
              <img src="https://fbb.obs.cn-east-3.myhuaweicloud.com/jpg/20250714165703_M77FY6.jpg" alt="订单方评分维度" className="rounded-xl shadow max-w-full h-64 object-cover mb-4" />
              <div className="font-semibold text-lg text-gray-800">订单方评分维度</div>
            </div>
            {/* 右侧图片及标题 */}
            <div className="flex flex-col items-center">
              <img src="https://fbb.obs.cn-east-3.myhuaweicloud.com/jpg/20250714165734_gPCAae.jpg" alt="加工厂评分维度" className="rounded-xl shadow max-w-full h-64 object-cover mb-4" />
              <div className="font-semibold text-lg text-gray-800">加工厂评分维度</div>
            </div>
          </div>
        </div>
      </section>

      {/* section E 平台实时数据 */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12">平台实时数据</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            {stats.map((stat, i) => (
              <div key={stat.label} className={`${stat.bg} rounded-xl py-8 shadow flex flex-col items-center`}>
                {stat.icon}
                <div className={`text-4xl font-bold ${stat.color} mb-2`}>
                  {animatedStats[i]}
                </div>
                <div className="text-gray-700 text-lg">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* section F 联系我们 */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12">联系我们</h2>
          <div className="grid grid-cols-2 md:grid-cols-5 gap-8 justify-items-center">
            {contactQRCodes.map((item, idx) => (
              <div key={idx} className="flex flex-col items-center">
                <img src={item.img} alt={item.label} className="mb-2 rounded-xl" />
                <div className="text-gray-700 mt-2">{item.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home; 